import script from "./TelegramChat.vue?vue&type=script&setup=true&lang=js"
export * from "./TelegramChat.vue?vue&type=script&setup=true&lang=js"

import "./TelegramChat.vue?vue&type=style&index=0&id=2d10c856&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d10c856"]])

export default __exports__